import React, {
  createContext,
  useReducer,
  useEffect,
  useContext,
  useState,
} from "react";
import AuthReducer from "./AuthReducer";
import * as authActions from "./AuthActionType";
import jwt_decode from "jwt-decode";
import {
  Redirect,
  withRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import { useSnackbar } from "notistack";

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  userId: "",
  userType: "",
  errorMessages: [],
  registerSuccess: [],
  userDetails: {},
  checkoutAsGuest: {},
  user_order_list: [],
};

export const AuthContext = createContext(initialState);

export const AuthContextProvider = (props) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);
  const [loader, setLoader] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  // console.log(state);
  // User Login
  async function userLogin(data) {
    try {
      delete axios.defaults.headers.common["Authorization"];
      dispatch({
        type: authActions.LOGIN_ATTEMPT,
        payload: "",
      });
      await axios.post("api/portal/login", data).then((response) => {
        // console.log("login_response", response.data.token);
        if (response.data.status == "success") {
          const tokenData = jwt_decode(response.data.token);
          window.localStorage.setItem(
            "frontend-jwt-token",
            response.data.token
          );

          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.token}`;
          dispatch({
            type: authActions.FRONTEND_LOGIN,
            payload: {
              userId: tokenData.sub,
            },
          });
          dispatch({
            type: authActions.SET_USER_DETAILS,
            payload: {
              userDetails: response.data.data,
              userType: response.data.type,
            },
          });
          // get_user_order_list();
          // getFavList();
          enqueueSnackbar("Logged in Succesfully", { variant: "success" });
          history.push("/profile?tab=dashboard");
        } else {
          // console.log(response.data);
          dispatch({
            type: authActions.LOGIN_ERROR,
            payload: "",
          });
          enqueueSnackbar("Invalid Username or Password", { variant: "error" });
        }
      });
    } catch (error) {
      console.log(error);
      delete axios.defaults.headers.common["Authorization"];
      window.localStorage.removeItem("frontend-jwt-token");
      enqueueSnackbar("Invalid Username or Password", { variant: "error" });
    }
  }

  function googleLogin(response) {
    axios.post("api/google_login", { response: response }).then((res) => {
      if (res.data.status == "success") {
        dispatch({
          type: authActions.FRONTEND_LOGIN,
          payload: res.data.token,
        });
        dispatch({
          type: authActions.SET_USER_DETAILS,
          payload: {
            userDetails: res.data.data,
            userType: res.data.type,
          },
        });
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.token}`;
        // get_user_order_list();
        // getFavList();
        enqueueSnackbar("Logged in Succesfully", { variant: "success" });
        // props.history.push('/profile');
      } else {
        // dispatch({
        //   type: authActions.LOGIN_ERROR,
        //   payload: res.data.message,
        // });
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
    });
  }
  function facebookLogin(response) {
    axios.post("api/facebook_login", { response: response }).then((res) => {
      if (res.data.status == "success") {
        dispatch({
          type: authActions.FRONTEND_LOGIN,
          payload: res.data.token,
        });
        dispatch({
          type: authActions.SET_USER_DETAILS,
          payload: {
            userDetails: res.data.data,
            userType: res.data.type,
          },
        });
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.token}`;
        // get_user_order_list();
        // getFavList();
        window.localStorage.removeItem("checkout-guest");
        enqueueSnackbar("Logged in Succesfully", { variant: "success" });
      } else {
        enqueueSnackbar(res.data.message, { variant: "success" });
      }
    });
  }

  async function socialLogin(data) {
    try {
      const response = await axios.post("api/portal/social-login", data);
      if (response.data.status === "success") {
        const tokenData = jwt_decode(response.data.token);
        window.localStorage.setItem("frontend-jwt-token", response.data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;
        dispatch({
          type: authActions.FRONTEND_LOGIN,
          payload: { userId: tokenData.sub },
        });
        dispatch({
          type: authActions.SET_USER_DETAILS,
          payload: {
            userDetails: response.data.data,
            userType: response.data.type,
          },
        });
        enqueueSnackbar("Logged in Successfully", { variant: "success" });
        history.push("/profile?tab=dashboard");
      } else {
        enqueueSnackbar(response.data.message || "Social login failed", { variant: "error" });
      }
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || "Social login failed";
      enqueueSnackbar(message, { variant: "error" });
    }
  }

  async function userRegister(data) {
    try {
      dispatch({
        type: authActions.LOGIN_ATTEMPT,
        payload: "",
      });
      const response = await axios.post("api/register", data);
      if (response.data.status == "success") {
        dispatch({
          type: authActions.FRONTEND_REGISTER,
          payload: response.data.message,
        });
        enqueueSnackbar(response.data.message, { variant: "success" });
        return true;
      } else if (response.data.status == "error") {
        enqueueSnackbar(response.data.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  }

  async function userLogout() {
    try {
      const token = window.localStorage.getItem("frontend-jwt-token");
      const tokenData = jwt_decode(token);
      const uType = tokenData.type;
      let url = "/api/seeker/logout";
      if (uType == "employer") {
        url = "/api/employer/logout";
      }
      dispatch({
        type: authActions.FRONTEND_LOGOUT,
        payload: "",
      });
      window.localStorage.removeItem("frontend-jwt-token");
      enqueueSnackbar("Logged Out", { variant: "success" });
      await axios.post(url).then((resp) => {
        delete axios.defaults.headers.common["Authorization"];
        if (resp.data.status == "success") {
          // dispatch({
          //   type: authActions.FRONTEND_LOGOUT,
          //   payload: "",
          // });
          // delete axios.defaults.headers.common["Authorization"];
          // window.localStorage.removeItem("frontend-jwt-token");
          // enqueueSnackbar("Logged Out", { variant: "success" });
        }
      });
      delete axios.defaults.headers.common["Authorization"];
    } catch (error) {
      dispatch({
        type: authActions.FRONTEND_LOGOUT,
        payload: "",
      });
      delete axios.defaults.headers.common["Authorization"];
      window.localStorage.removeItem("frontend-jwt-token");
      enqueueSnackbar(error.message, { variant: "error" });
    }
  }

  async function verifyEmailContext(data) {
    const token = window.localStorage.getItem("frontend-jwt-token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const res = await axios.post("api/verify_email", data);
    if (res.data.status == "success") {
      dispatch({
        type: authActions.SET_USER_DETAILS,
        payload: {
          userDetails: res.data.data,
          userType: res.data.type,
        },
      });

      enqueueSnackbar(res.data.message, { variant: "success" });
      return true;
    } else {
      enqueueSnackbar(res.data.message, { variant: "error" });
      return false;
    }
  }

  async function userResendVerifyCode(email) {
    const token = window.localStorage.getItem("frontend-jwt-token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const res = await axios.post("api/resend_verification_code", {
      email: email,
    });
    if (res.data.status == "success") {
      enqueueSnackbar(res.data.message, { variant: "success" });
    } else {
      enqueueSnackbar(res.data.message, { variant: "error" });
    }
  }

  async function save_user_profile(data) {
    const res = await axios.post("/api/customer/save_customer_profile", data);
    if (res.data.status == "success") {
      dispatch({
        type: authActions.SET_USER_DETAILS,
        payload: res.data.data,
      });
      // enqueueSnackbar("Profile Updated Succesfully", {variant:'success'});
    } else {
      // dispatch({
      //   type: authActions.LOGIN_ERROR,
      //   payload: res.data.message,
      // });
      // enqueueSnackbar( res.data.message, {variant:'error'});
    }
  }
  async function save_user_address(data) {
    const res = await axios.post("/api/customer/save_customer_address", data);
    if (res.data.status == "success") {
      dispatch({
        type: authActions.SET_USER_DETAILS,
        payload: res.data.data,
      });
      // enqueueSnackbar("Address Updated Succesfully", {variant:'success'});
    } else {
      // dispatch({
      //   type: authActions.LOGIN_ERROR,
      //   payload: res.data.message,
      // });
      // enqueueSnackbar( res.data.message, {variant:'error'});
    }
  }

  async function userChangePassword(data) {
    try {
      const response = await axios.post("api/customer_change_password", data);
      // console.log(response.data);
      if (response.data.status == "success") {
        // enqueueSnackbar(response.data.message, {variant:'success'});
        return ["success", response.data.message];
      } else {
        // enqueueSnackbar(response.data.message, {variant:'error'});
        return ["error", response.data.message];
      }
    } catch (error) {
      // enqueueSnackbar(error.message, {variant:'success'});
      return ["error", error.message];
    }
  }

  async function checkAuthentication() {
    const token = window.localStorage.getItem("frontend-jwt-token");
    if (token) {
      try {
        const tokenData = jwt_decode(token);
        const uType = tokenData.type;
        let url = "/api/seeker/user_detail";
        if (uType == "employer") {
          url = "/api/employer/user_detail";
        }
        if (tokenData.exp < new Date().getSeconds()) {
          userLogout();
        } else {
          setLoader(true);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          await axios.get(url).then((response) => {
            if (response.data.status == "success") {
              dispatch({
                type: authActions.SET_AUTH_USER,
                payload: {
                  userId: tokenData.sub,
                },
              });
              // console.log(response.data);
              dispatch({
                type: authActions.SET_USER_DETAILS,
                payload: {
                  userDetails: response.data.data,
                  userType: response.data.type,
                },
              });
              setLoader(false);
            }
          });
        }
      } catch (error) {
        window.localStorage.removeItem("frontend-jwt-token");
        dispatch({
          type: authActions.FRONTEND_LOGOUT,
          payload: "",
        });
      }
    }
  }

  async function guestCheckOut(data) {
    // console.log(data);
    const res = await axios.post("api/guest_checkout", data);
    if (res.data.status == "success") {
      dispatch({
        type: authActions.SET_CHECKOUT_DETAILS,
        payload: res.data.data,
      });
      window.localStorage.setItem(
        "checkout-guest",
        JSON.stringify(res.data.data)
      );
      // enqueueSnackbar("Logged In As Guest", {variant:'success'});
      return true;
    } else if (res.data.status == "error") {
      // enqueueSnackbar(res.data.message, {variant:'error'});
      return false;
    }
  }

  const get_user_order_list = async () => {
    const res = await axios
      .get("api/customer/order_list")
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
    if (res.data.status == "success") {
      dispatch({
        type: authActions.USER_ORDER_LIST,
        payload: res.data.data,
      });
    }
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: state.isAuthenticated,
        isLoading: state.isLoading,
        userId: state.userId,
        userType: state.userType,
        errorMessages: state.errorMessages,
        registerSuccess: state.registerSuccess,
        userDetails: state.userDetails,
        checkoutAsGuest: state.checkoutAsGuest,
        user_order_list: state.user_order_list,
        userLogin,
        loader,
        userLogout,
        userRegister,
        userChangePassword,
        save_user_profile,
        save_user_address,
        guestCheckOut,
        get_user_order_list,
        verifyEmailContext,
        userResendVerifyCode,
        googleLogin,
        facebookLogin,
        socialLogin,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default withRouter(AuthContextProvider);
